<template>
  <div class="homepage-3">
    <ScrollupSection />
    <div class="main">
      <HeaderSection />
      <HeroSection/>
      <FeatureSection />
      <WorkSection />
      <ServiceSection />
      <DiscoverSection />
      <ReviewSection />
      <PricingSection />
      <NewsletterSection />
      <DownloadSection />
      <ContactSection />
      <FooterSection />
    </div>
  </div>
</template>

<script>
import ScrollupSection from '../components/ScrollupSection/scrollUp'
import HeaderSection from '../components/HeaderSection/headerOne'
import HeroSection from '../components/HeroSection/heroThree'
import FeatureSection from '../components/FeatureSection/featureThree'
import WorkSection from '../components/WorkSection/work'
import ServiceSection from '../components/ServiceSection/serviceThree'
import DiscoverSection from '../components/DiscoverSection/discoverThree'
import ReviewSection from '../components/ReviewSection/reviewThree'
import PricingSection from '../components/PricingSection/pricingTwo'
import NewsletterSection from '../components/NewsletterSection/newsletter'
import DownloadSection from '../components/DownloadSection/download'
import ContactSection from '../components/ContactSection/contactGeneral'
import FooterSection from '../components/FooterSection/footerOne'

export default {
  name: 'ThemeThree',
  components: {
    ScrollupSection,
    HeaderSection,
    HeroSection,
    FeatureSection,
    WorkSection,
    ServiceSection,
    DiscoverSection,
    ReviewSection,
    PricingSection,
    NewsletterSection,
    DownloadSection,
    ContactSection,
    FooterSection
  }
}
</script>

<style>

</style>